import { createGlobalStyle } from 'styled-components';
const GlobalStyle = createGlobalStyle`
  body {
    padding: 0;
    margin: 0;
    font-family: 'Noto Sans';
  }
  a {
    text-decoration: none;
  }
  ul {
    margin: 0 auto;
    list-style-type: none;
  }
  h6 {
    color: '000',
    font-size: 16px
  }
  #___gatsby {
    height: 100vh;
  }
  #gatsby-focus-wrapper {
    height: 100vh;
  }
`;

export { GlobalStyle };
